import * as React from 'react';
import { C as Context, k as invariantIntlContext } from './injectIntl-d3879c1a.js';

function useIntl() {
    var intl = React.useContext(Context);
    invariantIntlContext(intl);
    return intl;
}

export { useIntl as u };
//# sourceMappingURL=useIntl-2a91ee7b.js.map
